import PropTypes from 'prop-types';

function IFHomeActive({ className, width }) {
    return (
        <svg width={width} viewBox="0 0 30 31" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
            <path
                d="M2.18999 11.3531C1.89695 14.3794 1.59858 22.723 2.18999 24.9661C2.34983 25.5629 26.9545 26.0317 26.9278 24.9661C26.7414 17.2778 26.9278 8.7584 26.9278 8.7584C26.9278 8.7584 1.8863 6.80302 1.91294 8.2256C1.93958 9.64817 2.18999 11.3531 2.18999 11.3531Z"
                fill="#F4F0F2"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.75222 7.71924C7.7706 8.19006 7.69373 8.65976 7.52623 9.10016C7.35873 9.54057 7.10404 9.94263 6.77743 10.2822C6.45081 10.6219 6.05899 10.892 5.62545 11.0766C5.19191 11.2611 4.72558 11.3563 4.25439 11.3563C3.78321 11.3563 3.31687 11.2611 2.88334 11.0766C2.4498 10.892 2.05798 10.6219 1.73136 10.2822C1.40475 9.94263 1.15006 9.54057 0.982556 9.10016C0.815055 8.65976 0.738191 8.19006 0.75657 7.71924H7.75222Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M14.8701 7.71924C14.8885 8.19006 14.8117 8.65976 14.6442 9.10016C14.4767 9.54057 14.222 9.94263 13.8953 10.2822C13.5687 10.6219 13.1769 10.892 12.7434 11.0766C12.3098 11.2611 11.8435 11.3563 11.3723 11.3563C10.9011 11.3563 10.4348 11.2611 10.0013 11.0766C9.56772 10.892 9.1759 10.6219 8.84928 10.2822C8.52267 9.94263 8.26798 9.54057 8.10048 9.10016C7.93298 8.65976 7.85611 8.19006 7.87449 7.71924H14.8701Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M21.8713 7.71924C21.8713 8.64763 21.5025 9.53799 20.8461 10.1945C20.1896 10.8509 19.2992 11.2197 18.3708 11.2197C17.4425 11.2197 16.5521 10.8509 15.8956 10.1945C15.2392 9.53799 14.8704 8.64763 14.8704 7.71924H21.8713Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M28.7764 7.84717C28.7764 8.77555 28.4076 9.66592 27.7511 10.3224C27.0946 10.9789 26.2043 11.3477 25.2759 11.3477C24.3475 11.3477 23.4571 10.9789 22.8007 10.3224C22.1442 9.66592 21.7754 8.77555 21.7754 7.84717H28.7764Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M4.7897 0.398682C3.53762 0.760985 0.255581 7.7886 0.820348 7.78327C4.27821 7.7513 28.9841 8.76362 28.7603 7.78327C28.4087 6.22217 26.5812 0.93148 24.791 0.750329C23.0008 0.569177 4.7897 0.398682 4.7897 0.398682Z"
                fill="#C5DB66"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.64398 25.4135L12.5048 25.5787C12.5048 25.5787 12.574 17.2883 12.5048 16.2973C12.3503 13.9477 7.54974 13.3562 6.86243 16.0416C6.59603 18.924 6.64398 25.4135 6.64398 25.4135Z"
                fill="#DD3D96"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path
                d="M22.793 15.3863C22.4041 15.3863 16.9322 14.9334 16.6125 15.3171C16.2929 15.7007 15.9306 19.9418 16.6125 20.1762C17.2945 20.4106 22.8356 20.8155 23.0914 20.1762C23.3471 19.5368 23.9385 15.4449 22.793 15.3863Z"
                fill="#DD3D96"
                stroke="#2D2D2D"
                strokeWidth="0.5"
                strokeMiterlimit="10"
            />
            <path d="M7.77881 8.15623L10.6612 0.398682" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M14.8704 8.46538L15.1794 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
            <path d="M21.7755 8.52399L19.8521 0.595947" stroke="#2D2D2D" strokeWidth="0.5" strokeMiterlimit="10" />
        </svg>
    );
}

export default IFHomeActive;

IFHomeActive.propTypes = {
    className: PropTypes.string,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

IFHomeActive.defaultProps = {
    className: null,
    width: 28,
};
